import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeAuthPlacement} from "../types/AmplitudeAuthPlacement";

export type AmplitudeUnlockChoiceModalName = "post_price_reveal" | "download_floor_plan" | "price_history" | "developer_report" | "construction_photos" | "faq";

export type AmplitudeModalName = "phone_verify" | "post_price_reveal_modal" | "rp_preferences" | "price_negotiate" | AmplitudeUnlockChoiceModalName;

export type AmplitudeModalLocation = "property_page" | "investment_page" | "listing_page" | "listing_map" | "homepage" | "rp_ai_chat" | null;

interface ITrackAmplitudeViewModalParams {
    modalName: AmplitudeModalName;
    location: AmplitudeModalLocation;
    phoneVerifyPlacement?: AmplitudeAuthPlacement | null;
    authPlacement?: AmplitudeAuthPlacement | null;
    itemId?: number | null;
    propertyId?: number | null;
}

export const trackAmplitudeViewModal = (params: ITrackAmplitudeViewModalParams): void => {
    trackAmplitudeEvent("view_modal", {
        modal_name: params.modalName,
        location: params.location,
        ...(params.phoneVerifyPlacement !== undefined && {phone_verify_placement: params.phoneVerifyPlacement}),
        ...(params.authPlacement !== undefined && {auth_placement: params.authPlacement}),
        ...(params.itemId !== undefined && {item_id: params.itemId}),
        ...(params.propertyId !== undefined && {property_id: params.propertyId})
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeAuthPlacement} from "../types/AmplitudeAuthPlacement";

export type AmplitudeUnlockChoiceModalName = "post_price_reveal" | "download_floor_plan" | "price_history" | "developer_report" | "construction_photos" | "faq";

export type AmplitudeModalName = "phone_verify" | "post_price_reveal_modal" | "rp_preferences" | "price_negotiate" | AmplitudeUnlockChoiceModalName;

export type AmplitudeModalLocation = "property_page" | "investment_page" | "listing_page" | "listing_map" | "homepage" | "rp_ai_chat" | null;

interface ITrackAmplitudeViewModalParams {
    modalName: AmplitudeModalName;
    location: AmplitudeModalLocation;
    phoneVerifyPlacement?: AmplitudeAuthPlacement | null;
    authPlacement?: AmplitudeAuthPlacement | null;
    itemId?: number | null;
    propertyId?: number | null;
}

export const trackAmplitudeViewModal = (params: ITrackAmplitudeViewModalParams): void => {
    trackAmplitudeEvent("view_modal", {
        modal_name: params.modalName,
        location: params.location,
        ...(params.phoneVerifyPlacement !== undefined && {phone_verify_placement: params.phoneVerifyPlacement}),
        ...(params.authPlacement !== undefined && {auth_placement: params.authPlacement}),
        ...(params.itemId !== undefined && {item_id: params.itemId}),
        ...(params.propertyId !== undefined && {property_id: params.propertyId})
    });
};
